// Dynamic styles based on theme - to be used with useThemedStyles.
export const createMyDocumentViewerStyles = ({ ui: { colors, type, space } }) => ({
	cardTitle: {
		marginBottom: space.sm,
	},
	cardButton: {
		alignSelf: 'flex-start',
		marginTop: space.md,
	},
	htmlBase: {
		...type.bodySmall,
		lineHeight: 21,
		color: colors.text,
	},
	mutedText: {
		...type.bodySmall,
		color: colors.textSecondary,
	},
	noticeText: {
		...type.bodySmall,
		color: colors.warning,
	},
	formField: {
		marginTop: space.sm,
		marginBottom: space.xs,
	},
	formLabel: {
		...type.fieldLabel,
		color: colors.text,
		marginBottom: space.xs,
	},
	privacyNotice: {
		marginBottom: space.md,
		padding: space.md,
		borderWidth: 1,
	},
	privacyNoticeText: {
		...type.secondary,
		color: colors.text,
	},
	formFooterNote: {
		...type.caption,
		color: colors.textFaint,
		marginTop: space.md,
	},
	submitButton: {
		marginTop: space.md,
	},
});
